export default __webpack_public_path__ + "static/1-d7fb9e1c5b26eb6b6bfe9dd4a40de5fa.png";